import { UserGroups } from "./../../../assets/config/models";
import { SharedService } from "./../../services/sharedService";
import { Component, inject, OnInit, signal } from "@angular/core";
import { AuthService } from "../../services/authService";
import { Router } from "@angular/router";
import { environment } from "../../../environments/environment";
import { CommonModule } from "@angular/common";
import { FormsModule } from "@angular/forms";
import { RegionModalComponent } from "../../shared/components/region-modal/region-modal.component";
import { ModalService } from "../../shared/services/modal.service";
import { RegionService } from "../../shared/services/region.service";

declare const toastr: any;

type userCredentials = { username: string; password: string };

@Component({
  selector: "app-login",
  templateUrl: "./login.component.html",
  styleUrls: ["./login.component.css"],
  providers: [AuthService],
  standalone: true,
  imports: [CommonModule, FormsModule, RegionModalComponent],
})
export class LoginComponent implements OnInit {
  private credentials = signal<userCredentials>({ username: "", password: "" });
  public username: string = "";
  public password: string = "";
  public hasForgottenPassword: boolean = false;
  public email: string = "";

  logo = environment.logo_path;
  groupTypes = UserGroups;

  private readonly authService: AuthService = inject(AuthService);
  private readonly router: Router = inject(Router);
  private readonly sharedService: SharedService = inject(SharedService);
  public modalService: ModalService = inject(ModalService);
  private readonly regionService: RegionService = inject(RegionService);

  ngOnInit() {
    const jwt = localStorage.getItem("jwt");
    const userDetails = localStorage.getItem("user_details");
    if (jwt != undefined && jwt != "" && userDetails) {
      this.authService.navigateUser(JSON.parse(userDetails));
    }
  }

  login() {
    this.credentials.set({
      username: this.username,
      password: this.password,
    });

    this.authService.login(this.credentials()).subscribe({
      next: () => {
        this.modalService.openModal();
      },
      error: () => {
        toastr.error("", "username and password combination is incorrect", {
          timeOut: 2000,
        });
      },
    });
  }

  toggleForgotPasswordClicked() {
    this.hasForgottenPassword = !this.hasForgottenPassword;
  }

  resetPassword() {
    const data = { email: this.email };

    this.authService.ResetPassword(data).subscribe({
      next: () => {
        toastr.success("", "Please check your email for the new password", {
          timeOut: 5000,
        });
        this.hasForgottenPassword = false;
      },
      error: () => {
        toastr.error("", "Email ID does not exists", { timeOut: 2000 });
      },
    });
  }

  onRegionSelected(regionCode: string) {
    const userDetails = localStorage.getItem("user_details");
    if (!userDetails) return;
    this.regionService.selectRegion(regionCode);
    this.modalService.closeModal();
    this.authService.navigateUser(JSON.parse(userDetails));
  }
}
